// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-brand-navigation-header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:hsla(0,0%,100%,.5)}.h-brand-navigation-header *+*{margin-left:4px}.h-brand-navigation-header__name{font-size:16px;line-height:16px;color:#fff}.h-brand-navigation-header__separator{padding:0 4px;font-size:8px}.h-brand-navigation-header__category{font-size:10px;line-height:10px}", ""]);
// Exports
module.exports = exports;
